import { Form } from "react-final-form";
import makeMutators from "@ticketingplatform/ui/dist/utils/finalForm/mutators";
import LoginLayout from "components/layouts/LoginLayout";
import { FormattedMessage } from "react-intl";

import { useLoginForm } from "./hooks";
import LoginStep1 from "./partials/Step1";
import LoginStep2 from "./partials/Step2";
import { LoginFormValues } from "./types";

const mutators = makeMutators<LoginFormValues>();
const Login: React.FC = () => {
  const loginFormProps = useLoginForm();
  const { step, onSubmit } = loginFormProps;
  const LOGIN_STEPS = [
    <LoginStep1 {...loginFormProps} />,
    <LoginStep2 {...loginFormProps} />,
  ];

  return (
    <LoginLayout title={<FormattedMessage defaultMessage="LOGIN" />} withLogo>
      <Form {...{ onSubmit, mutators }}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>{LOGIN_STEPS[step]}</form>
        )}
      </Form>
    </LoginLayout>
  );
};

export default Login;
